import React from 'react';
import PropTypes from 'prop-types';

import Page from './Page';

function PageList({ pages, orderedIds, onToggle }) {
  return (
    <ul className="hideable-pages-list">
      {orderedIds.map(pageId => (
        <Page
          key={pageId}
          id={pageId}
          type={pages[pageId].type}
          title={pages[pageId].menu_title}
          hidden={pages[pageId].hidden}
          onToggle={onToggle}
        />
      ))}
    </ul>
  );
}

PageList.propTypes = {
  pages: PropTypes.shape({}),
  orderedIds: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
  onToggle: PropTypes.func.isRequired,
};

export default PageList;



// WEBPACK FOOTER //
// ./src/components/manage/common/HidePagesModal/PageList.jsx